import { GraphQLClient } from 'graphql-request';
import { resourceLibraryGraphqlDomain } from '../utils/domains';

export const createResourceLibraryClient = ssId =>
	new GraphQLClient(resourceLibraryGraphqlDomain(), {
		headers: { 'x-ss-id': ssId },
	});
